<div
  [ngClass]="{
    'flex space-x-2 space-y-1': !smallSize,
    'grid gap-2 grid-cols-[32px_minmax(0,1fr)]': smallSize,
  }"
>
  <!-- User avatar -->
  <div
    class="flex flex-col flex-shrink-0"
    #userAvatarContainer
  >
    <svc-user-avatar [info]="userAvatar" />
  </div>

  <div class="flex flex-col" [ngClass]="{ 'flex-auto': hasImageOrAudioAttachment, 'space-y-1': smallSize }">
    <div class="relative flex flex-col rounded-b-2xl py-2 px-4 rounded-tr-2xl overflow-hidden" [ngClass]="{ 'bg-[#E4E7EA]': !message.isOwnerComment }" [style.background-color]="message.isOwnerComment ? 'var(--svc-own-comment-bg, rgb(var(--svc-color-primary-100-rgb)))' : null">
      <div class="flex flex-row justify-between items-center gap-2 mb-2"
        [class.blur-sm]="removingIsLoading || translatingIsLoading"
      >
        <span
          class="text-sm font-semibold min-w-0 break-words"
          [style.word-break]="'break-word'"
        >
          {{ message.user.name }}
        </span>
        <span
          class="text-xs text-default flex-shrink-0 whitespace-nowrap"
          [ngClass]="{
            'text-on-primary-100': message.user && !smallSize,
            'text-on-primary-50': !message.user && !smallSize,
            'opacity-50': !smallSize,
            'font-light opacity-1': smallSize,
          }"
        >
          {{ message.createDate | timeAgo }}
        </span>
      </div>

      <div
        *ngIf="message.commentText"
        class="text-base"
        [class.blur-sm]="removingIsLoading || translatingIsLoading"
        [innerHTML]="message.commentText | htmlSanitizer"
      ></div>

      <div
        class="px-2 py-1 rounded-lg bg-white mt-1"
        *ngIf="message.translatedCommentText"
        [class.blur-sm]="removingIsLoading || translatingIsLoading"
      >
        <div
          class="text-sm"
          [innerHTML]="message.translatedCommentText | htmlSanitizer"
        ></div>
      </div>

      <div
        *ngIf="mediasCarousel.length > 0"
        class="pt-2 print:hidden"
        [class.blur-sm]="removingIsLoading || translatingIsLoading"
      >
        <svc-media-carousel
          [renderMode]="mediaCarouselRenderMode"
          fitContent="contain"
          [items]="mediasCarousel"
          [height]="300"
          [playVideoWhenMouseHover]="false"
        />
      </div>

      <div
        *ngIf="mediasCarousel.length > 0"
        class="pt-2 hidden print:flex print:flex-col print:gap-3"
        [class.blur-sm]="removingIsLoading || translatingIsLoading"
      >
        <ng-container *ngFor="let media of mediasCarousel">
          <img
            *ngIf="media.type === 'image'"
            class="print-comment-media"
            [src]="media.url"
            [alt]="media.name || 'Comment image'"
          />
          <video
            *ngIf="media.type === 'video'"
            class="print-comment-media"
            [src]="media.url"
            controls
            preload="metadata"
          ></video>
        </ng-container>
      </div>

      <div
        *ngIf="attachments.length > 0"
        [class.blur-sm]="removingIsLoading || translatingIsLoading"
      >
        <div *ngFor="let attachment of attachments">
          <div
            *ngIf="attachment.type == AttachmentType.PDF"
            class="attachment-item text-default"
            (click)="openAttachment(attachment)"
          >
            <div class="attachment-file">
              <mat-icon
                class="text-current icon-size-6"
                svgIcon="fontawesome_solid:file-pdf"
              />
            </div>
            <div class="attachment-content">
              {{ attachment.name }}
            </div>
          </div>
          <div
            *ngIf="attachment.type == AttachmentType.COMPRESS"
            class="attachment-item text-default"
            (click)="openAttachment(attachment)"
          >
            <div class="attachment-file">
              <mat-icon
                class="text-current icon-size-6"
                svgIcon="fontawesome_solid:file-zipper"
              />
            </div>
            <div class="attachment-content">
              {{ attachment.name }}
            </div>
          </div>
          <div
            *ngIf="attachment.type == AttachmentType.EXCEL"
            class="attachment-item text-default"
            (click)="openAttachment(attachment)"
          >
            <div class="attachment-file">
              <mat-icon
                class="text-current icon-size-6"
                svgIcon="fontawesome_solid:file-excel"
              />
            </div>
            <div class="attachment-content">
              {{ attachment.name }}
            </div>
          </div>
          <div
            *ngIf="attachment.type == AttachmentType.POWER_POINT"
            class="attachment-item text-default"
            (click)="openAttachment(attachment)"
          >
            <div class="attachment-file">
              <mat-icon
                class="text-current icon-size-6"
                svgIcon="fontawesome_solid:file-powerpoint"
              />
            </div>
            <div class="attachment-content">
              {{ attachment.name }}
            </div>
          </div>
          <div
            *ngIf="attachment.type == AttachmentType.WORD"
            class="attachment-item text-default"
            (click)="openAttachment(attachment)"
          >
            <div class="attachment-file">
              <mat-icon
                class="text-current icon-size-6"
                svgIcon="fontawesome_solid:file-lines"
              />
            </div>
            <div class="attachment-content">
              {{ attachment.name }}
            </div>
          </div>
          <div
            *ngIf="attachment.type == AttachmentType.AUDIO"
            class="attachment-item text-default"
          >
            <div class="attachment-file">
              <mat-icon
                class="text-current icon-size-6"
                svgIcon="mat_solid:mic"
              />
            </div>
            <div class="attachment-content">
              <audio controls>
                <source [src]="attachment.assignUrl" />
              </audio>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="removingIsLoading || translatingIsLoading"
        class="loading-container"
      >
        <mat-spinner diameter="24" />
      </div>
    </div>

    <div class="flex flex-row flex-wrap text-sm text-default font-medium mt-0.5 min-h-5 items-center message-actions print:hidden">
      <div
        class="flex pr-1"
        [ngClass]="{ hidden: svcTotalReactions?.total <= 0 && !svcTotalReactions?.loading }"
      >
        <svc-total-reactions
          #svcTotalReactions
          class="flex"
          [registryUniqueId]="message.commentId"
          [reaction]="svcReaction"
          [applicationId]="'E07E98AE-9978-4C93-B787-1D961F7FE2E6'"
          [siteId]="siteId"
        />
      </div>
      <svc-reaction
        class="flex px-1"
        #svcReaction
        [ngClass]="{ 'border-l-0': svcTotalReactions?.total <= 0 && !svcTotalReactions?.loading }"
        [registryUniqueId]="message.commentId"
        [disabled]="removingIsLoading || translatingIsLoading"
        [applicationId]="'E07E98AE-9978-4C93-B787-1D961F7FE2E6'"
        positionX="left"
        [dontEmitFirstTime]="true"
        [siteId]="siteId"
        [parentApplicationId]="parentApplicationId"
        [parentRegisterId]="parentRegisterId"
        [parentRegisterUId]="parentRegisterUId"
        [parentOriginatorId]="message?.user?.id"
        [parentRegisterCode]="parentRegisterCode"
        [parentRegistryCode]="parentRegistryCode"
        [relativeFromElement]="reactionRelativeElementClass"
      >
        <a
          class="text-xs"
          [ngClass]="{ 'cursor-pointer': !removingIsLoading && !translatingIsLoading, 'text-primary': svcReaction.currentReactionType != null }"
          (click)="svcReaction.hasReacted && svcReaction.removeCurrentReaction()"
        >
          {{ 'Reagir' | transloco }}
        </a>
      </svc-reaction>
      <a
        *ngIf="!isChild"
        class="px-1 text-xs"
        [ngClass]="{ 'cursor-pointer': !removingIsLoading && !translatingIsLoading }"
        (click)="answer({ force: true, focus: true })"
      >
        {{ 'Responder' | transloco }}
      </a>
      <a
        *ngIf="!message.translated"
        class="px-1 text-xs"
        [ngClass]="{ 'cursor-pointer': !removingIsLoading && !translatingIsLoading }"
        (click)="translate()"
      >
        {{ 'Traduzir' | transloco }}
      </a>
      <a
        *ngIf="message.isOwnerComment"
        class="px-1 text-xs"
        [ngClass]="{ 'cursor-pointer': !removingIsLoading && !translatingIsLoading }"
        (click)="exclude()"
      >
        {{ 'Excluir' | transloco }}
      </a>
    </div>
    <div
      *ngIf="!showChildrenMessages && message.totalAnswers > 0"
      class="flex text-default font-medium print:hidden"
    >
      <a
        class="text-xs"
        [ngClass]="{ 'cursor-pointer': !removingIsLoading && !translatingIsLoading }"
        (click)="showMessages()"
      >
        {{ message.totalAnswers }} {{ 'resposta(s)' | transloco }}
      </a>
    </div>
  </div>
</div>

<svc-comments-chat
  #svcCommentsChatComponent
  *ngIf="showChildrenMessages"
  [style.paddingLeft.px]="smallSize ? 0 : userAvatarContainer.clientWidth + 16"
  class="block"
  [ngClass]="smallSize ? 'mt-6' : 'mt-3'"
  [referenceId]="message.commentId"
  [applicationId]="applicationId"
  [configTypeId]="configTypeId"
  [parentMessage]="message"
  [smallSize]="smallSize"
  [siteId]="siteId"
  [external]="external"
  [parentApplicationId]="parentApplicationId"
  [parentRegisterId]="parentRegisterId"
  [parentRegisterUId]="parentRegisterUId"
  [parentOriginatorId]="parentOriginatorId"
  [parentRegisterCode]="parentRegisterCode"
  [parentRegistryCode]="parentRegistryCode"
  (onCommentAdded)="onCommentAdded.emit($event)"
  (onCommentRemoved)="onCommentRemoved.emit($event)"
/>
